import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fourniss-detail-chiffre-contenue-fr',
  templateUrl: './fourniss-detail-chiffre-contenue.component.html',
  styleUrls: ['./fourniss-detail-chiffre-contenue.component.scss']
})
export class FournissDetailChiffreContenueComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
